// Library import
import { createRoot } from 'react-dom/client';
import { useEffect, useState } from 'react';
import Proptypes from 'prop-types';

// File Import
import siteLogo from '~/images/common/logo.png';
import comment from '~/images/icon/comment.png';
import jobless from '~/images/icon/jobless.png';
import skill from '~/images/icon/skill.png';
import book from '~/images/icon/book.png';
import analytic from '~/images/icon/analytic.png';
import management from '~/images/icon/management.png';
import lock from '~/images/icon/lock.png';
import logout from '~/images/icon/logout.png';

// Components Import
import { LogoutModal, ShowNonUserModal } from '@/components';

export const Header = ({ currentUser, version }) => {
  const url = new URL(window.location.href);
  const [typeParam, setTypeParam] = useState(null);
  const pathname = window.location.pathname;
  const [showNonUserModal, setShowNonUserModal] = useState(false);
  const [showLogoutModal, setLogoutModal] = useState(false);

  useEffect(() => {
    setTypeParam(`${url.searchParams.get('type')}`);
  }, []);

  return (
    <div className='sidebar-area'>
      {/* Site logo */}
      <div className='site-logo'>
        <div className='logo-inner'>
          <img src={siteLogo} alt='Site-logo' />
        </div>
      </div>

      <div className='header-nav'>
        {/* Navbar area */}
        <ul className='navbar-area'>
          <li className='nav-list'>
            <a
              href='/admin/posts?type=case_study'
              className={pathname.includes('/admin/posts') && typeParam === 'case_study' ? 'nav-item active' : 'nav-item'}>
              <img src={comment} alt='Sidebar icon' /> 就職活動事例（体験談）
            </a>
          </li>
          <li className='nav-list'>
            <a
              href='/admin/posts?type=job_hunting'
              className={pathname.includes('/admin/posts') && typeParam === 'job_hunting' ? 'nav-item active' : 'nav-item'}>
              <img src={jobless} alt='Sidebar icon' /> 就職活動支援メニュー
            </a>
          </li>
          <li className='nav-list'>
            <a
              href='/admin/posts?type=skill_support'
              className={pathname.includes('/admin/posts') && typeParam === 'skill_support' ? 'nav-item active' : 'nav-item'}>
              <img src={skill} alt='Sidebar icon' /> スキル習得支援メニュー
            </a>
          </li>
          <li className='nav-list'>
            <a
              href='/admin/posts?type=news'
              className={pathname.includes('/admin/posts') && typeParam === 'news' ? 'nav-item active' : 'nav-item'}>
              <img src={book} alt='Sidebar icon' /> 新着情報
            </a>
          </li>
          <li className='nav-list'>
            <a
              onClick={() => (currentUser?.admin === 1 ? window.open('/admin/users', '_self') : setShowNonUserModal(true))}
              className={pathname.includes('/admin/users') ? 'nav-item active' : 'nav-item'}>
              <img src={management} alt='Sidebar icon' /> アカウント管理
            </a>
          </li>

          <li className='nav-list'>
            <a href='/admin/activities' className={pathname.includes('/admin/activities') ? 'nav-item active' : 'nav-item'}>
              <img src={analytic} alt='Sidebar icon' /> アクセス履歴
            </a>
          </li>
          {/* <li className='nav-list'>
            <a onClick={(event) => event.preventDefault()} className='nav-item'>
              <img src={lock} alt='Sidebar icon' /> 分析
            </a>
          </li> */}
        </ul>

        {/* Logout action */}
        <div className='position-relative pb-3'>
          <button
            onClick={() => {
              setLogoutModal(true);
            }}
            className='button primary mb-5'>
            ログアウト <img src={logout} className='ms-2' style={{ width: '14px' }} alt='Sidebar icon' />
          </button>
          <div className='position-absolute ms-2 top-50'>{version}</div>
        </div>
      </div>

      {/* Logout modal */}
      {showNonUserModal && <ShowNonUserModal show={showNonUserModal} handleClose={() => setShowNonUserModal(false)} />}

      {/* Logout modal */}
      {showLogoutModal && <LogoutModal show={showLogoutModal} handleClose={() => setLogoutModal(false)} />}
    </div>
  );
};

Header.prototype = {
  currentUser: Proptypes.object,
  version: Proptypes.string
};

let element = null;

document.addEventListener('DOMContentLoaded', function (event) {
  if (!element) {
    element = document.getElementById('Header');
    const root = element && createRoot(element);
    const currentUser = element?.dataset?.user && JSON.parse(element.dataset.user);
    const version = element?.dataset?.version;

    if (element) root.render(<Header currentUser={currentUser} version={version} />);
  }
});
